import React, {useMemo} from 'react';
import {Layout, Spacer, Text} from '@di-nxt/components';
import dayjs from 'dayjs';
import {formatDuration, TeamMember} from '../../../../../services';
import {CourierInfoPopup} from './CourierInfoPopup';
import {t} from '../../../../../localization';

export type CourierInfoProps = {
  member: TeamMember | undefined;
  allocation: number;
  date: Date;
};
export const CourierInfo: React.FC<CourierInfoProps> = ({
  member,
  allocation,
  date,
}) => {
  const availability = member?.monthlyHours ?? 0;
  const formatHours = useMemo(() => {
    return allocation <= availability ? (
      <Text variant="inline_12_default">{`${formatDuration(
        allocation * 60,
      )}/${formatDuration(availability * 60)} ${t(
        'screens.schedule.couriercell.in',
      )} ${dayjs(date).format('MMM')} ${dayjs(date).format('YYYY')}`}</Text>
    ) : (
      <>
        <Text variant="inline_12_default">
          <Text
            variant="inline_12_emphasis"
            textColor="content_negative_default">
            {formatDuration(allocation * 60)}
          </Text>
          {`/${formatDuration(availability * 60)} ${t(
            'screens.schedule.couriercell.in',
          )} ${dayjs(date).format('MMM')} ${dayjs(date).format('YYYY')}`}
        </Text>
      </>
    );
  }, [date, allocation, availability]);

  return (
    <Layout centered paddingVertical="12" paddingRight="8">
      <Layout vertical justify="center">
        <CourierInfoPopup member={member} />
        <Spacer height="6" />
        {formatHours}
      </Layout>
    </Layout>
  );
};
